// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonPrimaryToggle = 1;
export var ButtonSecondaryToggle = 1;
export var ButtonTertiaryToggle = 1;
export var FieldsDefault = 1;
export var FieldsError = 2;
export var FieldsFocus = 2;
export var PaginationNumbered = 1;
export var Toggle = 2;